'use client'
import { ArrowRight } from '@carbon/icons-react'
import type { Prisma } from '@prisma/client'
import offerStateConfig from 'app/(main)/offers/_lib/offerStateConfig'
import { getFormattedDisplayDate } from 'lib/formatDate'
import Link from 'next/link'

export type OfferTeaserType = Prisma.OfferGetPayload<{
  select: {
    id: true
    slug: true
    title: true
    state: {
      orderBy: { createdAt: 'desc' }
      select: { createdAt: true; type: true }
    }
    costCenter: { select: { abacusNumber: true } }
  }
}>
export default function OfferTeaser({
  offer,
  includeDate = true,
  includeAbacusNumber = false,
}: {
  offer: OfferTeaserType
  includeDate?: boolean
  includeAbacusNumber?: boolean
}) {
  return (
    <Link
      href={`/offers/${offer.id}/${offer.slug}`}
      className="border-b-gray-20 hover:bg-gray-10 flex items-center justify-between gap-2 border-b-[1px] py-2 pr-4"
    >
      <div>
        <p>
          {offer.title || (
            <span className="text-text-placeholder">Unbenannte Offerte</span>
          )}
        </p>
        <div className="flex flex-col">
          {includeDate && offer.state[0] && (
            <span className="text-text-secondary text-xs">
              {offerStateConfig[offer.state[0].type].name} am{' '}
              {getFormattedDisplayDate(offer.state[0].createdAt)}
            </span>
          )}
          {includeAbacusNumber && (
            <span className="text-text-secondary text-xs">
              {offer.costCenter?.abacusNumber}
            </span>
          )}
        </div>
      </div>
      <span className="h-4 w-4">
        <ArrowRight />
      </span>
    </Link>
  )
}
